import { useLang } from "../i18n/LanguageContext";
import { Reveal, Page } from "../components/Reveal";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";

const Privacidade = () => {
  const { t } = useLang();

  return (
    <Page>
      <SEO title={t.meta.privacidade.title} desc={t.meta.privacidade.desc} />
      <PageHero eyebrow="Bloom" title={t.privacyPage.title} desc={t.privacyPage.updated} testid="privacy-hero" />
      <section className="bg-cream pb-24 sm:pb-32" data-testid="privacy-content">
        <div className="mx-auto max-w-3xl space-y-6 px-5 sm:px-8">
          {t.privacyPage.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div className="rounded-3xl bg-white p-7 ring-1 ring-blush">
                <h2 className="font-serif text-xl font-semibold text-ink">{s.t}</h2>
                <p className="mt-3 text-[15px] leading-relaxed text-ink/60">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </Page>
  );
};

export default Privacidade;
